import React from 'react'

import config from 'config'

import BaseTemplate from 'components/templates/BaseTemplate'
import AptitudeTestimonies from 'components/organisms/AptitudeTestimonies'

import AptitudeIntro from './AptitudeIntro'
import WhatIsAptitude from './WhatIsAptitude'
import AptitudeExplanation from './AptitudeExplaination'
import RIASECExplanation from './RIASECExplanation'
import AptitudeFAQ from './AptitudeFAQ'
import AptitudeExplore from './AptitudeExplore'
import AptitudeStickyContent from './AptitudeStickyContent'

const { assets_url: assetsUrl } = config

const AptitudeLanding = () => (
  <BaseTemplate
    firstSection=".aptitude-intro"
    stickyBottomContent={
      <AptitudeStickyContent />
    }
    useStickyBottom
    useNewHeader
  >
    <div className="aptitude-landing">
      <AptitudeIntro />
      <WhatIsAptitude />
      <AptitudeExplanation />
      <RIASECExplanation />
      <div className="aptitude-landing__testimonies-faq">
        <AptitudeTestimonies />
        <AptitudeFAQ />
      </div>
      <AptitudeExplore />
    </div>
    <style jsx>
      {`
        .aptitude-landing {
          &__testimonies-faq {
            background-color: #bcefe2;
            @media screen and (min-width: 768px) {
              background-image: url('${assetsUrl}/assets/img/aptitude/green-dots.svg');
              background-position: top 360px right;
              background-repeat: no-repeat;
            }
          }
        }
      `}
    </style>
  </BaseTemplate>
)

export default AptitudeLanding
